import _extends from "@babel/runtime/helpers/extends";
import { getClientId } from "@smartsheet/lodestar-utils";
import React from "react";
import { useTheme } from "../../../../theme/utils/useTheme";
import { DatePickerTextInputPlaceholderStyled } from "../styled/DatePickerTextInputPlaceholderStyled";
export const DatePickerTextInputPlaceholder = _ref => {
  let {
    clientId,
    format,
    validationState,
    value,
    isFocused,
    focusMode,
    variant = "box",
    ...rest
  } = _ref;
  const {
    key
  } = useTheme();
  const themeMode = key;
  return /*#__PURE__*/React.createElement(DatePickerTextInputPlaceholderStyled, _extends({
    "data-client-id": getClientId(clientId, "dp-input-placeholder"),
    themeMode: themeMode,
    validationState: validationState,
    isFocused: isFocused,
    focusMode: focusMode,
    variant: variant
  }, rest), /*#__PURE__*/React.createElement("span", {
    className: "sds__user-input"
  }, value), /*#__PURE__*/React.createElement("span", {
    className: "sds__format-placeholder"
  }, format.substring(value.length)));
};
//# sourceMappingURL=DatePickerTextInputPlaceholder.js.map